import { createStore } from 'vuex'
import axios from 'axios'
import { ElMessage } from 'element-plus'

// 创建axios实例
const api = axios.create({
  baseURL: '/api',
  timeout: 60000
})
// 请求拦截器
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
api.interceptors.response.use(
  response => {
    // 检查响应类型，如果是二进制数据（blob或arraybuffer），直接返回响应
    if (response.config.responseType === 'blob' || response.config.responseType === 'arraybuffer') {
      return response
    }
    // 检查响应的code字段，如果code不是200，就将其视为错误响应
    if (response.data && (response.data.code !== 200 && response.data.code !== '200')) {
      const error = new Error(response.data.message || '请求失败')
      error.response = response
      return Promise.reject(error)
    }
    return response.data
  },
  error => {
    if (error.response) {
      const status = error.response.status
      if (status === 403) {
        // 登录过期处理
        if (!window.isLoggingOut) {
          window.isLoggingOut = true
          ElMessage.error('登录已过期，请重新登录')
          localStorage.removeItem('token')
          localStorage.removeItem('userInfo')
          setTimeout(() => {
            window.location.href = '/'
          }, 1500)
        }
        return new Promise(() => {})
      } else if (status === 401) {
        ElMessage.error('未登录或登录失效，请重新登录')
        localStorage.removeItem('token')
        localStorage.removeItem('userInfo')
        setTimeout(() => {
          window.location.href = '/'
        }, 1500)
        return new Promise(() => {})
      }
    }
    return Promise.reject(error)
  }
)

const store = createStore({
  state: {
    token: localStorage.getItem('token') || '',
    userInfo: (() => {
      try {
        const userInfoStr = localStorage.getItem('userInfo');
        if (userInfoStr === 'undefined' || userInfoStr === undefined) {
          return null;
        }
        return JSON.parse(userInfoStr || 'null');
      } catch (error) {
        return null;
      }
    })()
  },
  mutations: {
    setToken(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
    },
    logout(state) {
      state.token = ''
      state.userInfo = null
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
    }
  },
  actions: {
    // 登录
    async login({ commit }, loginData) {
      // 对密码做可逆混淆（注意：这不是加密，无法提供安全性，
      // 传输安全完全依赖 HTTPS；后端按同样规则还原后校验）
      const encryptPassword = (password) => {
        // 混淆步骤：
        // 1. 拼接固定盐值（盐在前端源码中公开，不构成保密）
        // 2. 反转字符串
        // 3. Base64 编码（可逆编码，任何人可解码）
        let encrypted = password + 'expenses_reimbursement_salt'; // 拼接盐值

        // 反转字符串
        encrypted = encrypted.split('').reverse().join('');

        // Base64编码
        encrypted = btoa(encrypted);

        return encrypted;
      };

      // 混淆密码
      const encryptedPassword = encryptPassword(loginData.password);

      // 发送混淆后的密码
      const response = await api.post('/user/login', {
        username: loginData.username,
        password: encryptedPassword
      });
      
      commit('setToken', response.data.token);
      commit('setUserInfo', response.data.userInfo);
      return response;
    },
    // 退出登录
    logout({ commit }) {
      commit('logout')
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    userInfo: state => state.userInfo,
    isAdmin: state => state.userInfo && state.userInfo.role === 'ADMIN',
    isDeptManager: state => state.userInfo && state.userInfo.role === 'DEPT_MANAGER',
    userRole: state => state.userInfo ? (state.userInfo.role || 'EMPLOYEE') : 'EMPLOYEE'
  }
})

export default store
export { api }
